import React, { useState } from 'react';
import { Button, message } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import TicketCard from './TicketCard';
import './ticketOptions.less';
import { Event, EventTicket, EventTicketDeliveryMethod } from '../../sportsAndEventsInterface';

interface TicketOptionsProps {
  event: any;
  tickets: EventTicket[];
  isPackageView?: boolean;
  isDynamicPackage?: boolean;
  isPreviewMode?: boolean;
  handleSelectTicket?: ({
    ticket,
    quantity,
    deliveryMethod,
  }: {
    ticket: any;
    quantity: number;
    deliveryMethod: any;
  }) => void;
  handleRemoveTicket?: (ticketId: number) => void;
  selectedTicket?: {
    eventInfo: Event;
    ticket: EventTicket;
    quantity: number;
    deliveryMethod: EventTicketDeliveryMethod;
  };
  selectedTickets?: {
    eventInfo: Event;
    ticket: EventTicket;
    quantity: number;
    deliveryMethod: EventTicketDeliveryMethod;
  }[];
  onQuantityChange?: (quantity: number, ticketId?: number) => void;
  onDeliveryMethodChange?: (deliveryMethod: any, ticketId?: number) => void;
  initialQuantity?: number;
  scrollable?: boolean;
}

const TicketOptions: React.FC<TicketOptionsProps> = ({
  event,
  tickets,
  selectedTicket,
  selectedTickets,
  isPackageView = false,
  isDynamicPackage = false,
  isPreviewMode = false,
  handleSelectTicket,
  handleRemoveTicket,
  onQuantityChange,
  onDeliveryMethodChange,
  initialQuantity,
  scrollable = false,
}) => {
  const { sportsAndEvents: t_sportsAndEvents } = useSelector(
    (data: RootState) => data.config.translations
  );

  // Use selectedTickets if provided, otherwise fall back to single ticket
  const effectiveSelectedTickets = selectedTickets || (selectedTicket ? [selectedTicket] : []);
  const hasAnySelected = effectiveSelectedTickets.length > 0;

  return (
    <div className="ticket-options">
      <h2 className="section-title">{t_sportsAndEvents?.selectTickets}</h2>

      <div className={`tickets-list ${scrollable ? 'scrollable' : ''}`}>
        {tickets && tickets.length > 0 ? (
          tickets.map((ticket) => {
            const isSelected = effectiveSelectedTickets.some(
              (t) => t.ticket?.id === ticket.id
            );
            const selectedTicketData = effectiveSelectedTickets.find(
              (t) => t.ticket?.id === ticket.id
            );

            return (
              <TicketCard
                key={ticket.id}
                ticket={ticket}
                event={event}
                isPackageView={isPackageView}
                isDynamicPackage={isDynamicPackage}
                isPreviewMode={isPreviewMode}
                handleSelectTicket={handleSelectTicket}
                handleRemoveTicket={handleRemoveTicket}
                onQuantityChange={onQuantityChange}
                onDeliveryMethodChange={onDeliveryMethodChange}
                initialQuantity={selectedTicketData?.quantity || initialQuantity}
                initialDeliveryMethod={selectedTicketData?.deliveryMethod}
                renderButtonInside={scrollable}
                isSelected={isSelected}
                hasAnySelected={hasAnySelected}
                totalSelectedCount={effectiveSelectedTickets.length}
              />
            );
          })
        ) : (
          <div className="no-tickets">
            {t_sportsAndEvents?.noTicketsAvailable}
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketOptions;
